type status = {
    name: string;
    description: string;
};
const AllStatus: status[] = [
    {
        name: 'outstanding',
        description: 'Outstanding',
    },
    {
        name: 'received',
        description: 'Received',
    },
    {
        name: 'rejected',
        description: 'Rejected by User',
    },
    /* {
        name: 'attention',
        description: 'Needs Client Attention',
    },
    {
        name: 'under-review',
        description: 'Under Review',
    },
    {
        name: 'scheduled',
        description: 'Scheduled',
    },
    {
        name: 'completed',
        description: 'Completed',
    },
    {
        name: 'submitted',
        description: 'Submitted',
    }, */
];

export default AllStatus;
